import { FormsEntities, FormsActionTypes } from '@bimser/common';
import { createSyncAction, IBaseAction } from '@bimser/core';
import { put, takeEvery } from 'redux-saga/effects';

export default function* watchModelChanged() {
	yield takeEvery(FormsActionTypes.MODEL_CHANGE_TRANSACTION, modelChanged);
}

export function* modelChanged(sagaAction: IBaseAction<FormsEntities.ModelChangeAction>) {
	const payload: FormsEntities.PropertyChangeAction = sagaAction.payload.payload;
	const action = createSyncAction(sagaAction.payload.orginalActionKey, payload);
	yield put(action);
}
